import { FunctionComponent, ReactElement } from 'react';
import { MenuItem } from '@mui/material';
import TextField, { TextFieldProps } from './TextField';
import { SelectInputProps } from '../select-input/SelectInput';

type SelectFieldProps = SelectInputProps & TextFieldProps;

const SelectField: FunctionComponent<SelectFieldProps> = ({ options, ...rest }): ReactElement => (
	<TextField select {...rest}>
		{options?.map(({ value, label }) => (
			<MenuItem key={value} value={value}>
				{label}
			</MenuItem>
		))}
	</TextField>
);

export default SelectField;
